import type { DataStore } from '../data/store';
import type { FlowQuery, SeriesResult, StockQuery } from '../data/types';

export function labelStockSeries(
  result: SeriesResult,
  query: Pick<StockQuery, 'breakdown'>,
  store: DataStore,
): SeriesResult {
  return {
    ...result,
    series: result.series.map((series) => ({
      ...series,
      colorKey:
        query.breakdown === 'account'
          ? `account:${series.id}`
          : query.breakdown === 'group'
            ? `group:${series.id}`
            : 'aggregate:total',
      label:
        query.breakdown === 'account'
          ? store.accountLabel(series.id)
          : query.breakdown === 'group'
            ? store.groupLabel(series.id)
            : 'Totale',
    })),
  };
}

export function labelFlowSeries(
  result: SeriesResult,
  query: Pick<FlowQuery, 'breakdown'>,
  store: DataStore,
): SeriesResult {
  return {
    ...result,
    series: result.series.map((series) => ({
      ...series,
      colorKey:
        query.breakdown === 'account'
          ? `account:${series.id}`
          : query.breakdown === 'group'
            ? `group:${series.id}`
            : query.breakdown === 'category' || query.breakdown === 'rollup-category'
              ? series.id === '__uncategorized__'
                ? 'category:uncategorized'
                : `category:${series.id}`
              : 'aggregate:total',
      label:
        query.breakdown === 'account'
          ? store.accountLabel(series.id)
          : query.breakdown === 'group'
            ? store.groupLabel(series.id)
            : query.breakdown === 'category' || query.breakdown === 'rollup-category'
              ? store.categoryLabel(series.id === '__uncategorized__' ? null : series.id)
              : 'Totale',
    })),
  };
}
